import script from "./blfjjp.vue?vue&type=script&setup=true&lang=js"
export * from "./blfjjp.vue?vue&type=script&setup=true&lang=js"

import "./blfjjp.vue?vue&type=style&index=0&id=19bb8b93&lang=scss&scoped=true"

import exportComponent from "/home/lw8dl1214/actions-runner/_work/AIPR-Frontend/AIPR-Frontend/haleon-ar-detector/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-19bb8b93"]])

export default __exports__